// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	production: false,
	//api_url: 'http://127.0.0.1:8005/',
	api_url: 'https://api.staging.nextleap.ai/',
	// api_url: 'http://192.168.1.2:8005/',
	// api_url: 'http://192.168.29.229:8005/',
	api_key: 'HvwRHcpGSQ1zlBaSaWMVq3ehcnSLjr858Xrunk2u',
	places_key: 'AIzaSyBGV-RcEQpG1aGjUe1tLBWh50reEiTEZvE',
	file_upload_url: 'https://n0sj18bqv2.execute-api.ap-south-1.amazonaws.com/dev/get_presigned_url_to_upload_files'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
